import { useContext } from 'react';
import type { FormState } from '@gonfalon/legacy-forms/formUtils';
import { FormContext } from '@gonfalon/legacy-forms/formUtils';
import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';

export type SubmitButtonProps = Omit<ButtonProps, 'Kind'> & {
  kind?: 'primary' | 'destructive';

  // SubmitButton does not care or know about the type form state.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formState?: FormState<any>;
  loadingText?: string;
};

export function SubmitButton(props: SubmitButtonProps) {
  const { kind = 'primary', formState: formStateProp, isDisabled, children, loadingText, ...other } = props;

  const formState = useContext(FormContext)?.formState || formStateProp;
  const loading = formState?.isFormSubmitting();
  const text = loading ? loadingText : children;
  let shouldDisable = !formState?.canSubmitForm();
  if (isDisabled !== null && typeof isDisabled !== 'undefined') {
    shouldDisable = loading || isDisabled;
  }

  return (
    <Button type="submit" {...other} isPending={loading} variant={kind} isDisabled={shouldDisable}>
      {text}
    </Button>
  );
}
